module.exports = __webpack_public_path__ + "img/icon-user_disabled.3426031b.png";